import { ReactElement } from 'react';
import { MessageModalLayoutProps } from '@wix/design-system';

export type MultiCollectionBulkActionToolbarRenderProps = (props: {
  readonly allSelected: boolean;
  readonly isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  clearSelection: () => void;
  openConfirmModal: (props?: Partial<MessageModalLayoutProps>) => void;
}) => ReactElement;

export type MultiCollectionBulkActionModalRenderProps = (props: {
  allSelected: boolean;
  readonly isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  clearSelection: () => void;
  openConfirmModal: (props?: Partial<MessageModalLayoutProps>) => void;
}) => ReactElement;
